import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgLayers(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M17.875 11L20 12.049 12 16l-8-3.951L6.123 11 12 13.903zm0-4L20 8.048 12 12 4 8.048 6.123 7 12 9.902zM12 0l8 4-8 4-8-4z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Layers')(SvgLayers);
